





define(['http', './utils', 'endpoints', 'security'],
    function(http, utils, endpoints, security) {
        'use strict';

        var queryParamNames = ['unit', 'thickness', 'openLr'];

        return {
            flowSegmentData: function(options, callback) {
                var pathParams = {};
                var queryParams = {};

                //check to see if a point is specified
                queryParams.point = utils.required(options.point, 'Missing point required parameter');

                //check to see if a style is specified
                pathParams.style = utils.required(options.style, 'Missing style required parameter');

                //check to see if a zoom is specified
                pathParams.zoom = utils.required(options.zoom, 'Missing zoom required parameter');

                // if an API key is specified, include it
                // an API key can be omitted if an API proxy is being used
                queryParams.key = utils.or(options.key, security.getKey('services/traffic'));

                utils.extractQueryParams(options, queryParams, queryParamNames);

                http.get({
                    url: '{protocol}://' + endpoints.flowSegmentData,
                    pathParameters: pathParams,
                    queryParameters: queryParams,
                    callback: callback,
                    fail: options.fail
                });
            }
        };
    }
);



// WEBPACK FOOTER //
// ./rest/flowSegmentData.js